export default __webpack_public_path__ + "static/media/logo.d3892f36.png";